export function getAutoNumberAbbreviation(value: number) {
    if (value < 1000) return { value, abbreviation: undefined }
    if (value < 1000000) return { value: value / 1000, abbreviation: 'K' }
    if (value < 1000000000) return { value: value / 1000000, abbreviation: 'M' }
    if (value < 1000000000000) return { value: value / 1000000000, abbreviation: 'B' }
    return { value: value / 1000000000000, abbreviation: 'T' }
}
